import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { HelperService } from '../../../shared/services/helper.service';
import { environment } from '../../../../environments/environment';
import { ToastService } from '../../../shared/services/toast.service';
import { HttpService } from '../../../shared/services/http.service';

@Component({
  selector: 'app-wp',
  templateUrl: './wp.component.html',
  styleUrl: './wp.component.css',
})
export class WpComponent implements OnInit, OnDestroy {
  brandListSubs!: Subscription;
  memeberListsByWPSubs!: Subscription;
  isEditMode: boolean = true;
  @Input() wpList: any = {};
  @Input() brandLists: any = [];
  @Input() businessThemeLists: any = [];
  @Input() teamMembersLists: any = [];
  @Input() loading: boolean = false;
  @Input() userData: any;
  isWorkPackage: boolean = true;
  httpService = inject(HttpService);
  helper = inject(HelperService);
  toastService = inject(ToastService);
  @Output() createFormWP: EventEmitter<any> = new EventEmitter<any>();
  @Output() updateFormWP: EventEmitter<any> = new EventEmitter<any>();


  messageService = inject(MessageService);
  onGoingTaskMemberLists: any = [];
  summaryText: any = '';
  quarterlyOutcomes: boolean = false;
  wpSummaryModal: boolean = false;
  wpWorkPackage: boolean = false;
  attachmentModal: boolean = false;
  viewMode: boolean = false;
  showSummaryTitle: string;
  quarterlyOutcomesLists: any = [];

  submitSummary(): void {
    if (this.summaryText) {
      const payload = {
        review: this.summaryText,
        package_id: this.wpList?.package_id,
      };
      this.httpService
        .post(
          `${environment.opbBackendHost}/api/member/workpackage/mark/closed`,
          payload
        )
        .subscribe((response: any) => {
          if (response) {
            response?.error
              ? this.toastService.error(response?.message)
              : this.toastService.success(response?.message);
            this.closeSummaryDialog();
          }
        });
    } else {
      console.error('Summary text is required!');
    }
  }

  closeModal(event: any) {
    this.wpWorkPackage = event;
  }

  closeDownlaodModal(event: any) {
    this.attachmentModal = event;
  }

  fetchQuarterlyOutcomesLists() {
    let data = {
      package_id: this.wpList?.package_id,
    };
    this.httpService
      .post(
        `${environment.opbBackendHost}/api/member/workpackage/quarterly/outcomes`,
        data
      )
      .subscribe((res: any) => {
        this.quarterlyOutcomesLists = res.data;
      });
  }

  viewSummary() {
    this.viewMode = true;
    this.wpSummaryModal = true;
    this.showSummaryTitle = 'View Summary';
    this.summaryText = this.wpList.review;
  }

  // Close the dialog
  closeSummaryDialog(): any {
    this.wpSummaryModal = false;
  }

  ngOnInit(): void {
    // this.helper.fetchMemeberListsByWP(this.wpList?.package_id);
    this.memeberListsByWPSubs = this.helper.memeberListsByWP$.subscribe(
      (data: any) => {
        this.onGoingTaskMemberLists = data;
      }
    );
    this.viewMode = false;
    this.showSummaryTitle = 'Add Summary';
  }

  ngOnDestroy() {
    this.brandListSubs?.unsubscribe();
    this.memeberListsByWPSubs?.unsubscribe();
  }
  createSummary() {
    this.summaryText=null
    this.wpSummaryModal = true;
  }

  updateWorkPackage() {
    this.helper.fetchMemeberListsByWP(this.wpList?.package_id);
    this.wpWorkPackage = true;
  }

  showAttachment() {
    this.attachmentModal = true;
  }

  downloadFile(file: { name: string; url: string }) {
    const link = document.createElement('a');
    link.href = file.url;
    link.download = file.name;
    link.target = '_blank';
    link.click();
  }

  showQuarterlyOutcomes() {
    this.fetchQuarterlyOutcomesLists();
    this.quarterlyOutcomes = !this.quarterlyOutcomes;
  }

  maxVisibleMembers = 3;

  get visibleMembers() {
    return (
      this.wpList?.members
        .filter((m: any) => m.place == 'member')
        .slice(0, this.maxVisibleMembers) || []
    );
  }

  get extraMembers() {
    return (
      this.wpList?.members
        .filter((m: any) => m.place === 'member')
        .slice(this.maxVisibleMembers) || []
    );
  }
}
